import { z } from 'zod';

import { PRODUCT_DIMENSION_NAME } from '../consts';

const productSchema = z.array(
  z.object({
    [PRODUCT_DIMENSION_NAME]: z.string().trim(),
  }),
);

export const extractProductsFromCsvData = (
  csvData: unknown[],
): { id: string; description: string }[] | null => {
  const { data, error } = productSchema.safeParse(csvData);

  if (error) {
    return null;
  }

  return data
    .filter((value) => value[PRODUCT_DIMENSION_NAME])
    .map((value) => ({
      id: value[PRODUCT_DIMENSION_NAME],
      description: value[PRODUCT_DIMENSION_NAME],
    }));
};
